import { createFileRoute } from "@tanstack/react-router";
import ShowroomFloorPlanDebug from "lib/components/debug/ShowroomFloorPlanDebug";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../components/withAuthentication";

function ShowroomFloorPlanDebugPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Showroom Floor Plan Debug")}</title>
        <meta name="robots" content="noindex" />
      </Head>

      <ShowroomProvider>
        <ShowroomFloorPlanDebug />
      </ShowroomProvider>
    </>
  );
}

export const Route = createFileRoute("/debug/showroom-floorplan")({
  component: withAuthentication(ShowroomFloorPlanDebugPage, { superAdmin: true }),
});
